import { kstDate } from './data';

// Never render future buckets as zero-income performance. Use the server's snapshot time.
export function visibleTrend(data) {
    if (!data) return [];
    const cutoff = Math.min(Date.parse(data.as_of), Date.parse(data.range.end_at));
    return data.trend.filter(p => Date.parse(p.bucket_start) >= Date.parse(data.range.start_at) && Date.parse(p.bucket_start) <= cutoff).sort((a, b) => Date.parse(a.bucket_start) - Date.parse(b.bucket_start));
}
export function weeklyTrend(points) {
    const weeks = new Map();
    for (const point of points) {
        const date = kstDate(new Date(point.bucket_start));
        const day = new Date(`${date}T00:00:00Z`);
        day.setUTCDate(day.getUTCDate() - (day.getUTCDay() + 6) % 7);
        const key = day.toISOString().slice(0, 10);
        const entry = weeks.get(key) || { bucket_start: point.bucket_start, start: date, end: date, earnings: 0 };
        entry.end = date;
        entry.earnings += point.earnings;
        weeks.set(key, entry);
    }
    return [...weeks.values()].map(p => ({ ...p, label: `${p.start.slice(5).replace('-', '/')} ~ ${p.end.slice(5).replace('-', '/')}` }));
}
